import { progressAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { COLOR_SETS } from '../tokens';
import { resolveColor } from '../utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(progressAnatomy.keys);

// Exports
export const Progress = defineMultiStyleConfig({
  baseStyle: definePartsStyle((props) => {
    return {
      track: {
        borderRadius: '1rem',
      },
      filledTrack: {
        '&[role="progressbar"]': {
          background: resolveColor(props, COLOR_SETS.mutedText[0]),
          borderRightRadius: '0rem',
        },
      },
    };
  }),
});
